import type { TokenCredential } from "@azure/identity";
import { grantKeyVaultSecretsUser, resolveKeyVaultResourceId } from "./rbac.js";

/** Read delivery creds out of an agent's env map (raw --env or the brain path set them). */
export function detectDeliveryEnv(
  env: Record<string, string | undefined>,
): { installationId?: string; kvUri?: string } {
  const rawInstall = env.GITHUB_APP_INSTALLATION_ID?.trim();
  const installationId = rawInstall !== undefined && rawInstall !== "" ? rawInstall : undefined;
  const rawKv = env.AZURE_KEYVAULT_URI?.trim();
  const kvUri = rawKv !== undefined && rawKv !== "" ? rawKv : undefined;
  return { installationId, kvUri };
}

/** Normalize a bare vault name OR a full vault URI to a canonical vault URI. */
export function normalizeKvUri(input: string): string {
  const v = input.trim();
  return /^https?:\/\//i.test(v) ? v : `https://${v}.vault.azure.net/`;
}

/** Grant the agent identity Key Vault Secrets User on the delivery KV. Idempotent (409=ok). */
export async function ensureDeliveryGrant(args: {
  credential: TokenCredential;
  subscriptionId: string;
  principalId: string;
  kvUri: string;
}): Promise<void> {
  const kvScope = await resolveKeyVaultResourceId({
    credential: args.credential,
    subscriptionId: args.subscriptionId,
    kvUri: args.kvUri,
  });
  await grantKeyVaultSecretsUser({
    credential: args.credential,
    subscriptionId: args.subscriptionId,
    kvScope,
    principalId: args.principalId,
  });
}
